import { NgModule } from '@angular/core'
import { QRCodeModule } from 'angularx-qrcode'
import { SharedModule } from 'src/app/shared/shared.module'
import { CommonComponentsModule } from '../components/common-components.module'
import { RecommendContentHorizontalListComponent } from '../components/recommend-content-horizontal-list/recommend-content-horizontal-list.component'
import { AlarmAppInstallModalComponent } from './alarm-app-install-modal/alarm-app-install-modal.component'
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component'
import { AskNavigationIntroModal } from './ask-navigation-intro'
import { AskCreateComponent } from './ask/ask-create/ask-create.component'
import { BottomSheetHeaderComponent } from './bottom-sheet-header/bottom-sheet-header.component'
import { ChangeRespondentNameComponent } from './change-respondent-name/change-respondent-name.component'
import { FavourTournamentChemiOnboardingCardComponent } from './chemi-onboarding-card/chemi-onboarding-card.component'
import { CoupangAdModalComponent } from './coupang-add-modal/coupang-ad-modal.component'
import { LoginAlertDialogComponent } from './login-alert-dialog/login-alert-dialog.component'
import { LoginInstallChoiceModalComponent } from './login-install-choice-modal/login-install-choice-modal.component'
import { MbtiCreateAlertComponent } from './mbti-create-alert/mbti-create-alert.component'
import { MenuDialogComponent } from './menu-dialog/menu-dialog.component'
import { MessageExampleComponent } from './message-example/message-example.component'
import { NoneKakaoLoginModalComponent } from './none-kakao-login-modal/none-kakao-login-modal.component'
import { PhoneInputModalComponent } from './phone-input/phone-input.component'
import { ProfileGuideComponent } from './profile-guide/profile-guide.component'
import { QrCodeModalComponent } from './qr-code-modal/qr-code-modal.component'
import { GuestQuizReportSelectorComponent } from './quiz-report-selector/guest-quiz-report-selector/guest-quiz-report-selector.component'
import { HostQuizReportSelectorComponent } from './quiz-report-selector/host-quiz-report-selector/host-quiz-report-selector.component'
import { ResultSaveAlertDialogComponent } from './result-save-alert-dialog/result-save-alert-dialog.component'
import { SelectOptionModalComponent } from './select-option/select-option.component'
import { SubShareComponent } from './sub-share/sub-share.component'
import { TermAgreementComponent } from './term-agreement/term-agreement.component'
import { WebInstallChoiceModalComponent } from './web-install-choice-modal/web-install-choice-modal.component'
import { GoogleAdModalComponent } from './google-ad-modal/google-ad-modal.component'
import { AppAdModalComponent } from './app-ad-modal/app-ad-modal.component'

@NgModule({
  declarations: [
    MenuDialogComponent,
    SubShareComponent,
    BottomSheetHeaderComponent,
    AlertDialogComponent,
    HostQuizReportSelectorComponent,
    GuestQuizReportSelectorComponent,
    QrCodeModalComponent,
    ChangeRespondentNameComponent,
    SelectOptionModalComponent,
    TermAgreementComponent,
    PhoneInputModalComponent,
    AskCreateComponent,
    AskNavigationIntroModal,
    MbtiCreateAlertComponent,
    MessageExampleComponent,
    LoginAlertDialogComponent,
    FavourTournamentChemiOnboardingCardComponent,
    AlarmAppInstallModalComponent,
    ResultSaveAlertDialogComponent,
    ProfileGuideComponent,
    CoupangAdModalComponent,
    NoneKakaoLoginModalComponent,
    LoginInstallChoiceModalComponent,
    RecommendContentHorizontalListComponent,
    WebInstallChoiceModalComponent,
    GoogleAdModalComponent,
    AppAdModalComponent,
  ],
  imports: [CommonComponentsModule, SharedModule, QRCodeModule],
  exports: [
    MenuDialogComponent,
    SubShareComponent,
    BottomSheetHeaderComponent,
    AlertDialogComponent,
    HostQuizReportSelectorComponent,
    GuestQuizReportSelectorComponent,
    QrCodeModalComponent,
    ChangeRespondentNameComponent,
    SelectOptionModalComponent,
    TermAgreementComponent,
    PhoneInputModalComponent,
    AskCreateComponent,
    AskNavigationIntroModal,
    MbtiCreateAlertComponent,
    MessageExampleComponent,
    LoginAlertDialogComponent,
    FavourTournamentChemiOnboardingCardComponent,
    ResultSaveAlertDialogComponent,
    ProfileGuideComponent,
    CoupangAdModalComponent,
    NoneKakaoLoginModalComponent,
    LoginInstallChoiceModalComponent,
    RecommendContentHorizontalListComponent,
    WebInstallChoiceModalComponent,
    AppAdModalComponent,
  ],
})
export class CommonModalsModule {}
